module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAwAQMAAACcxzBJAAAAAXNSR0IArs4c6QAAAAZQTFRFAAAAHyMpTgayjwAAAAF0Uk5TAEDm2GYAAAAVSURBVBjTY/gPAf8YSGIMEjDyHA8AAFaPXzS8MeYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_menu02.png
// module id = S9hZ
// module chunks = 5